// src/api/smart/login.js
import React from 'react';
import { Modal, Input, message } from 'antd';

const API_BASE_URL = 'https://accountingAPI.smartlogic.mn/oauth/token';
let modalInstance = null;

export function showLoginModal() {
  return new Promise((resolve) => {
    let username = '';
    let password = '';

    modalInstance = Modal.confirm({
      title: '',
      width: 420,
      centered: true,
      icon: null, // Hide default AntD icon
      content: (
        <div style={{ textAlign: 'center' }}>
          {/* SmartLogic Logo - simple and clean, no cropping */}
          <img
            src="/api_icon/Smart.png"
            alt="SmartLogic Logo"
            style={{
              width: '240px',
              height: 'auto',
              display: 'block',
              margin: '0 auto 32px auto', // Top and bottom margin, centered
            }}
          />

          <div style={{ marginBottom: 16 }}>
            <Input
              placeholder="Username"
              allowClear
              autoFocus
              onChange={(e) => (username = e.target.value)}
            />
          </div>
          <Input.Password
            placeholder="Password"
            onChange={(e) => (password = e.target.value)}
            onPressEnter={() => modalInstance?.confirm()}
          />
        </div>
      ),
      okText: 'Login',
      cancelText: 'Cancel',
      onOk: async () => {
        if (!username.trim() || !password) {
          message.error('Please enter username and password');
          return false;
        }

        const params = new URLSearchParams();
        params.append('username', username.trim());
        params.append('password', password);
        params.append('grant_type', 'password');

        try {
          const response = await fetch(API_BASE_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: params,
          });

          const data = await response.json();

          if (!response.ok) {
            throw new Error(
              data.error_description || data.error || 'Login failed'
            );
          }

          const token = {
            access_token: data.access_token,
            token_type: data.token_type || 'bearer',
            expires_in: data.expires_in || 86399,
            expires_at: Date.now() + (data.expires_in || 86399) * 1000,
          };

          saveToken(token);
          message.success('Login successful!');
          resolve({ state: true, token });
        } catch (err) {
          const msg = err.message || 'Login failed';
          message.error(msg);
          resolve({ state: false, message: msg });
          return false;
        }
      },
      onCancel: () => {
        resolve({ state: false, message: 'Cancelled' });
      },
    });
  });
}

// Token helpers (unchanged)
export function saveToken(token) {
  localStorage.setItem('smart_api_token', JSON.stringify(token));
}

export function getToken() {
  const raw = localStorage.getItem('smart_api_token');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearToken() {
  localStorage.removeItem('smart_api_token');
}
